// A collection of schemas management utility functions and converters that are used on the administration side of schemas / blueprints.

// Given a list of schema objects that includes both regular + relation schemas, we convert this into a tree structure suitable for a DxTreeView.
// Note that the relations already have a 'field' in each of the related schemas, so we don't need to handle that.
const schemaListToTree = (data) => {
	let ret = [];
	// For all schemas, just add them to the tree.
	data.forEach(schemaRow => {
		schemaRow.keyspec = schemaRow.type;
		schemaRow.isExpanded = false;
		if (!schemaRow.fields)
			schemaRow.fields = [];
		for (let f of schemaRow.fields) {
			f.keyspec = schemaRow.type + '.' + f.field;
		}
		schemaRow.fields.push({ keyspec: schemaRow.type + '._new', fieldtype: 'internal', internal: true, label: 'New field...', schema_id: schemaRow.id });
		ret.push(schemaRow);
	});
	/* This was old code to dupe relation schemas to auto-create fields. We might use this to add sub-trees later on to the relationship fields.
	ret.forEach(schemaRow => {
		if (!schemaRow.is_relation || merge_mode == 'hide')
			return;
		let dupeTargets = [...new Set(schemaRow.meta.aType.concat(schemaRow.meta.aType))];
		for (let dupeTarget of dupeTargets) {
			let foundDupe = ret.find(s => s.type == dupeTarget);
			if (!foundDupe)
				continue;
			if (merge_mode == 'field') {
				foundDupe.fields.push({
					keyspec: dupeTarget + '.' + schemaRow.type,
					fieldtype: 'relationship',
					label: schemaRow.singular,
					schema_id: schemaRow.id,
				});
			} else if (merge_mode == 'tree') {
				let clonedSchema = JSON.parse(JSON.stringify(schemaRow));
				clonedSchema.keyspec = dupeTarget + '.' + clonedSchema.keyspec;
				for (let f of clonedSchema.fields) {
					f.keyspec = dupeTarget + '.' + f.keyspec;
				}
				foundDupe.fields.push(clonedSchema);
			}
		}
	});
	*/

	ret = ret.filter(s => !s.is_relation);
	ret.unshift({
		keyspec: '_new',
		internal: true,
		singular: 'New blueprint...',
	});
	console.log(ret);
	return ret;
};

export { schemaListToTree };